import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        className="space-y-8"
      >
        <div className="relative inline-block">
          <AlertCircle size={120} className="text-brand-orange/20" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-6xl font-black text-brand-black">404</span>
          </div>
        </div>
        
        <div className="space-y-4">
          <h1 className="text-4xl md:text-6xl font-black text-brand-black uppercase italic">
            ROUTE <span className="text-brand-orange text-glow">LOST.</span>
          </h1>
          <p className="text-brand-muted text-lg max-w-md mx-auto font-medium">
            The logistics route you are looking for has been diverted or doesn't exist. Let's get you back on track.
          </p>
        </div>

        <button 
          onClick={() => window.location.href = '/'}
          className="bg-brand-black text-white px-10 py-5 rounded-2xl font-black text-lg flex items-center gap-4 hover:bg-brand-orange transition-all shadow-xl hover:shadow-brand-orange/40 mx-auto"
        >
          <ArrowLeft size={24} /> 
          RETURN TO HUB
        </button>
      </motion.div>
    </div>
  );
};

export default NotFound;
